import request from "@/utils/request";

// 微信客户端登录
export function clientLogin(
  code,
  agentCode = "06595eebe6c140c4b63828d7d1ab8ead"
) {
  return request.post(
    `/user/oauth/token?client_id=weChat&client_secret=weChat&grant_type=weChat&code=${code}&agentCode=${agentCode}`
  );
}
